import { dialog1, dialog2, dialog7 } from '../utils/dialog';
import { LOGIN_OUT, LOGIN_IN, LOGIN_CANCEL, USER_UPDATE } from './action-types';

import { CURRENT_HOST } from '../constant';

let timer;
export const login_out = (login_other = false) => {
  if (login_other) {
    dialog1('⏰异地登录提醒', '用户在其他地方登录', false);
  } else {
    dialog2('已退出登录', true);
  }
  return {
    type: LOGIN_OUT,
    user: '',
  };
};
export const auto_login = (pcinfo, user_cookie) => {
  return (dispatch) => {
    const req = fetch(
      `https://${CURRENT_HOST}/cookie_login?pcinfo=` +
        pcinfo +
        '&openid=' +
        user_cookie
    );
    req
      .then((r) => r.json())
      .then((res) => {
        if (res.state === 200 && res.login) {
          dispatch({
            type: LOGIN_IN,
            user: user_cookie,
          });
        } else {
          dispatch(login_out());
        }
      });
  };
};
export const login_in = (qr = {}) => {
  return (dispatch) => {
    timer = setInterval(() => {
      console.log('login_in action');
      const req = fetch(`https://${CURRENT_HOST}/fresh_qr`, {
        method: 'PUT',
        body: JSON.stringify({
          ...qr,
        }),
      });
      req
        .then((r) => r.json())
        .then((res) => {
          if (res.state === 200) {
            clearInterval(timer);
            dialog2('登录成功！欢迎您', true);
            dispatch({
              type: LOGIN_IN,
              user: res.user,
            });
          } else if (res.state == 204) {
            throw 'close';
          }
        })
        .catch((err) => {
          clearInterval(timer);
        });
    }, 200);
  };
};
export const login_cancel = (qr = {}) => {
  fetch(`https://${CURRENT_HOST}/fresh_qr`, {
    method: 'DELETE',
    body: JSON.stringify({
      ...qr,
    }),
  });
  return {
    type: LOGIN_CANCEL,
  };
};
export const user_update = (user) => {
  return {
    type: USER_UPDATE,
    user,
  };
};
